export const GET_DASHBOARD = "GET_DASHBOARD";
export const UPDATE_DASHBOARD = "UPDATE_DASHBOARD";
export const SET_LOADING = "SET_LOADING";
export const DASHBOARD_ERROR = "DASHBOARD ERROR";
export const RESET_DASHBOARD = "RESET";
export const SHOW_HIDE_EMPLOYEE_GROUP_LOCATION = "SHOW_HIDE_EMPLOYEE_GROUP_LOCATION";
export const SHOW_HIDE_CUSTOMER_GROUP_LOCATION = "SHOW_HIDE_CUSTOMER_GROUP_LOCATION";
export const SHOW_HIDE_EMPLOYEE_MOSAIC_LOCATION = "SHOW_HIDE_EMPLOYEE_MOSAIC_LOCATION";
export const SHOW_HIDE_CUSTOMER_MOSAIC_LOCATION = "SHOW_HIDE_CUSTOMER_MOSAIC_LOCATION";
export const UPDATE_EMPLOYEE_COLOR = "UPDATE_EMPLOYEE_COLOR";
export const UPDATE_CUSTOMER_COLOR = "UPDATE_CUSTOMER_COLOR";
